'use client'

import { AudioBars } from '@/components/client/audio/variants/audio-bars'

export interface AudioFileClientProps {
  audioUrl: string
  caption?: string
  editableProps?: Record<string, unknown>
}

export const AudioFileClient = ({ audioUrl, caption, editableProps }: AudioFileClientProps) => {
  return (
    <section className="n4-audio-file w-full max-w-[640px] [&+.n4-audio-file]:mt-[-24px]" {...editableProps}>
      <AudioBars url={audioUrl} title={caption} />
    </section>
  )
}
